import { action, CubePresenter, FlipIntent, Logger } from 'wdc-cube'

import { MainPresenter } from 'src/main/Main.presenter'
import { GrupoFormKeys } from 'src/modules/grupo/form'
import analiseService from '../analise.service'
import { AnaliseSelectKeys } from './analise_select.keys'
import AnaliseSelectScope from './analise_select.scopes'

const LOG = Logger.get('AnaliseSelectPresenter')

export class AnaliseSelectPresenter extends CubePresenter<MainPresenter, AnaliseSelectScope> {
    // :: Constructor
    public constructor(app: MainPresenter) {
        super(app, new AnaliseSelectScope())
    }

    // :: Methods
    #grupoId?: number

    public override release() {
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new AnaliseSelectKeys(this.app, intent)

        keys.dialogSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }
        if (keys.grupoId) {
            this.#grupoId = keys.grupoId
        }

        await this.handleFind()

        return keys.allow
    }

    async #initialize() {
        LOG.debug('initialize')

        this.scope.onClose = this.handleClose.bind(this)
        this.scope.onFind = this.handleFind.bind(this)
        this.scope.onSelect = this.handleSelect.bind(this)
    }

    @action()
    private async handleFind() {
        try {
            const analises = await analiseService.fetchAnalisesAtivas()
            this.scope.analises = analises
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        }
    }

    @action()
    private async handleSelect() {
        if (this.scope.idSelected <= 0) {
            this.app.notify('warning', 'Análise deve ser selecionada')
            return
        }
        const key = new GrupoFormKeys(this.app)
        key.addAnaliseId = this.scope.idSelected
        key.grupoId = this.#grupoId!
        await key.flip()
        this.app.scope.dialog = undefined
    }

    @action()
    private async handleClose() {
        const key = new GrupoFormKeys(this.app)
        key.grupoId = this.#grupoId!
        await key.flip()
        this.app.scope.dialog = undefined
    }
}

export default AnaliseSelectPresenter
